import { render, staticRenderFns } from "./HomeLegacy.vue?vue&type=template&id=6d46c5b1&scoped=true&"
import script from "./HomeLegacy.vue?vue&type=script&lang=js&"
export * from "./HomeLegacy.vue?vue&type=script&lang=js&"
import style0 from "./HomeLegacy.vue?vue&type=style&index=0&id=6d46c5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46c5b1",
  null
  
)

export default component.exports